import { IAppTheme } from "..";

const Palette = (theme: IAppTheme): any => ({
  primary: {
    contrastText: theme.primaryContrast,
    main: theme.primary,
  },
  secondary: {
    contrastText: theme.secondaryContrast,
    main: theme.secondary,
  },
});

export default Palette;
